'use client';
import React, { forwardRef } from 'react';
import { isFilledString } from '../../utils/string.mjs';

/**
 * AnchorButton
 * - href가 있으면 a태그, 없으면 button태그를 적용합니다.
 */
const AnchorButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    disabled,
    onClick,
    ...props
  } = _ref;
  const handleClickAnchor = event => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    return onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  if (isFilledString(props.href)) {
    return /*#__PURE__*/React.createElement("a", {
      ...props,
      ref: ref,
      onClick: handleClickAnchor
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      ...props,
      ref: ref,
      disabled: disabled,
      onClick: onClick
    }, children);
  }
});
AnchorButton.displayName = 'AnchorButton';

export { AnchorButton as default };
